import { RuleFormContent } from '@/components/rules/form/RuleFormContent';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogTrigger } from '../../ui/dialog';

// Re-export shared types for backward compatibility
export type {
  RulePresets,
  RuleFormValues,
} from '@/components/rules/form/rule-form-types';
import type { RulePresets } from '@/components/rules/form/rule-form-types';

interface CreateRuleDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  presets?: RulePresets;
  rawRule?: string;
  targetGroupId?: string;
  children?: React.ReactNode;
}

export const CreateRuleDialog: React.FC<CreateRuleDialogProps> = ({
  open: controlledOpen,
  onOpenChange,
  presets,
  rawRule,
  targetGroupId,
  children,
}) => {
  const { t } = useTranslation();
  const [internalOpen, setInternalOpen] = useState(false);
  const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
  const setOpen = onOpenChange || setInternalOpen;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {!children && controlledOpen === undefined && (
        <DialogTrigger asChild>
          <Button className='gap-2 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white border-0'>
            <Plus className='w-4 h-4' />
            {t('rules.createRule')}
          </Button>
        </DialogTrigger>
      )}
      <DialogContent className='max-w-5xl max-h-[90vh] overflow-y-auto overflow-x-hidden p-0'>
        <RuleFormContent
          key={presets?.id || 'create'}
          presets={presets}
          rawRule={rawRule}
          targetGroupId={targetGroupId}
          onClose={() => setOpen(false)}
          isPanel={false}
        />
      </DialogContent>
    </Dialog>
  );
};
